import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Icon from '../../Icon';
import HeadingUppercase from '../../HeadingUppercase';
import { getIconDirection, SORT_ASC } from '../hooks/useColumnSort';
import useHoverFocus from '../hooks/useHoverFocus';

var HeaderText = function HeaderText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(HeadingUppercase, {
    truncate: true,
    color: "foregroundSecondary",
    cursor: "inherit"
  }, children);
};

var HeaderSort = function HeaderSort(_ref2) {
  var affordance = _ref2.affordance,
      column = _ref2.column,
      currentSort = _ref2.currentSort,
      defaultSort = _ref2.defaultSort,
      sorted = _ref2.sorted;
  return /*#__PURE__*/React.createElement(Icon, {
    size: "xs",
    name: getIconDirection(currentSort.columnId === column.id ? currentSort.direction : column.defaultSortDirection || (defaultSort ? defaultSort.direction : SORT_ASC)),
    opacity: sorted ? 1 : affordance ? 0.4 : 0
  });
};

function HeaderCell(_ref3) {
  var cellRef = _ref3.cellRef,
      column = _ref3.column,
      columnIndex = _ref3.columnIndex,
      columnSort = _ref3.columnSort,
      defaultSort = _ref3.defaultSort,
      restProps = _objectWithoutPropertiesLoose(_ref3, ["cellRef", "column", "columnIndex", "columnSort", "defaultSort"]);

  var currentSort = columnSort.currentSort,
      sortColumnById = columnSort.sortColumnById;

  var _useHoverFocus = useHoverFocus(),
      isHoverFocus = _useHoverFocus.isHoverFocus,
      bind = _useHoverFocus.bind;

  if (column.sortable) {
    restProps.tabIndex = 0;
    restProps['aria-sort'] = currentSort.columnId === column.id ? currentSort.direction === 'ASC' ? 'ascending' : 'descending' : 'none';

    restProps.onClick = function () {
      sortColumnById(column);
    };

    restProps.onKeyDown = function (event) {
      if (event.key === 'Enter') {
        sortColumnById(column);
      }
    };
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: cellRef,
    role: "columnheader"
  }, restProps, bind), typeof column.header === 'string' ? /*#__PURE__*/React.createElement(HeaderText, null, column.header) : /*#__PURE__*/React.isValidElement(column.header) ? column.header : column.header ? /*#__PURE__*/React.createElement(column.header, {
    columnIndex: columnIndex
  }) : null, column.sortable && /*#__PURE__*/React.createElement(HeaderSort, {
    defaultSort: defaultSort,
    currentSort: currentSort,
    column: column,
    sorted: currentSort.columnId === column.id,
    affordance: isHoverFocus
  }));
}

export default HeaderCell;